// extracted by mini-css-extract-plugin
export default {"instructions":"add_pangolin_mnemonic_instructions__UPgK-","textarea":"add_pangolin_mnemonic_textarea__C0smx","action":"add_pangolin_mnemonic_action__pDIk9"};